module.exports = __webpack_public_path__ + "img/venueone-fdbottom.54b2fa52.png";